// extracted by mini-css-extract-plugin
export default {"locationSuggestions":"_38GxX","containerOptions":"_32lww"};